import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPostRequest,
  apiPutRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { kmMessages } from "src/constant/Messages";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const EventForm = ({
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [calendarEvent, setCalendarEvent] = useState();
  const editMode = rest.kmaction === "edit";
  const [calendarEventStartDate, setCalendarEventStartDate] = useState(null);
  const [calendarEventEndDate, setCalendarEventEndDate] = useState(null);
  const [formReady, setFormReady] = useState(false);

  let pageTitle =
    rest.kmaction === "new" ? "Nowe wydarzenie" : "Edycja wydarzenia";

  useEffect(() => {
    if (editMode) {
      enableGlobalLoader();
      apiGetByIdRequest(apiEndpoints.getCalendarEventDetails.path, entryId, true)
        .then((data) => {
          disableGlobalLoader();
          setCalendarEvent(data);

          setFormReady(true);
        })
        .catch((error) => {
          disableGlobalLoader();
        });
    } else {
      setFormReady(true);
    }

    return () => {};
  }, []);

  const onSubmit = (values) => {

    enableGlobalLoader();

    if (editMode) {
      apiPutRequest(
        apiEndpoints.updateCalendarEvent.path,
        {
          id: entryId,
          name: values.name,
          startsAt: calendarEventStartDate.format("YYYY-MM-DDTHH:mm:ss"),
          endsAt: calendarEventEndDate.format("YYYY-MM-DDTHH:mm:ss"),
          url: values.url,
          urlLabel: values.urllabel
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate("/kalendarz/zarzadzaniewydarzenia");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          
          } else if (error.response.status === 400 && error.response.data) {
            if (error.response.data.code === "CALENDAR_ENTRY_END_DATE_TO_OLD") {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.calendar.calendarevent_dateendtoold,
              });
            } else if (
              error.response.data.code === "CALENDAR_ENTRY_START_DATE_TO_OLD"
            ) {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.calendar.calendarevent_datestarttoold,
              });
            } else if (
              error.response.data.code === "CALENDAR_ENTRY_START_DATE_OLDER_THAN_END"
            ) {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message:
                  kmMessages.error.calendar.calendarevent_dateendolderthanstart,
              });
            }
          }
        });
    } else {
      apiPostRequest(
        apiEndpoints.createCalendarEvent.path,
        {
          name: values.name,
          startsAt: calendarEventStartDate.format("YYYY-MM-DDTHH:mm:ss"),
          endsAt: calendarEventEndDate.format("YYYY-MM-DDTHH:mm:ss"),
          url: values.url,
          urlLabel: values.urllabel
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate("/kalendarz/zarzadzaniewydarzenia");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          } else if (error.response.status === 400 && error.response.data) {
            if (error.response.data.code === "CALENDAR_ENTRY_END_DATE_TO_OLD") {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.calendar.calendarevent_dateendtoold,
              });
            } else if (
              error.response.data.code === "CALENDAR_ENTRY_START_DATE_TO_OLD"
            ) {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.calendar.calendarevent_datestarttoold,
              });
            } else if (
              error.response.data.code === "CALENDAR_ENTRY_START_DATE_OLDER_THAN_END"
            ) {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message:
                  kmMessages.error.calendar.calendarevent_dateendolderthanstart,
              });
            }
          }
        });
    }
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form
            formReady={formReady}
            onSubmit={onSubmit}
            calendarEvent={calendarEvent}
            calendarEventStartDate={calendarEventStartDate}
            setCalendarEventStartDate={setCalendarEventStartDate}
            calendarEventEndDate={calendarEventEndDate}
            setCalendarEventEndDate={setCalendarEventEndDate}
            editMode={editMode}
          />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
});

export default connect(null, mapDispatchToProps)(EventForm);
